import {fork, takeEvery, takeLatest, put, putResolve, select} from "redux-saga/effects";
import {applicationThemeResult, ChatSettingActions} from "../actions/chat-setting-actions";
import {getApplicationThemeApi} from "../common/api";


function* getApplicationTheme() {
    const resp = yield getApplicationThemeApi();
    console.log("----debug BOS 12----", resp);
    if (resp && resp.status === "success") {
        // let payLoad = {
        //     payload: false,
        //     action: refreshSessionAction(payload.payload)
        // }
        yield put(applicationThemeResult(resp.data));
    } else {
        // sessionStorage.setItem(SESSION_ID, resp.conversationSessionId);
        // yield put(payload.payload.action)
    }
}


function* mySaga(){
    yield takeEvery(ChatSettingActions.APPLICATION_THEME, getApplicationTheme);
}


const chatSettingSaga = [fork(mySaga)];

export default chatSettingSaga;